import React from "react";

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const footerText = `${currentYear} Jersium®, a TimChief Ventures P.S.A. Brand. Copyright© - All Rights Reserved.`;

  return (
    <div className="bg-black">
      <div className="max-w-[1440px] mx-auto w-full h-[37px] px-[136px] justify-center items-center flex flex-row">
        <div className="text-white text-[14px] leading-[14px] font-normal">
          {footerText}
        </div>
      </div>
    </div>
  );
}
